<template>
  <div id="cat">
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row mb-2">
          <div class="vx-col lg:w-1/3 w-full">
            <label class="vs-select--label">{{ $t("Search") }}</label>
            <vs-input
              name="user"
              :placeholder="$t('ItemCode')"
              v-model="gridSearchData.itemCode"
              @keyup.enter="search()"
            />
          </div>
          <div class="vx-col lg:w-1/12 w-full">
            <vs-button
              class="mt-6 p-2"
              color="success"
              type="gradient"
              icon-pack="feather"
              icon="icon-search"
              @click.prevent="search()"
            ></vs-button>
          </div>
          <div class="vx-col lg:w-7/12 w-full">
            <vs-button
              class="mt-6 p-2 float-right"
              color="success"
              type="gradient"
              @click.prevent="isUpdateDataFromKhadamat()"
              v-has-permission="permission244"
              >{{ $t("UpdateDataFromKhadamat") }}</vs-button
            >
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('ProductCode') },
                { title: 'avasysNameMain' },
                { title: $t('ItemCode') },
                { title: 'avasysName' },
                { title: $t('Action') },
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 15%">
                  {{ row.productCode }}
                </td>
                <td style="direction: ltr; width: 30%">
                  {{ row.avasysNameMain }}
                </td>
                <td style="width: 15%">
                  {{ row.itemCode }}
                </td>
                <td style="width: 25%">
                  {{ row.avasysName }}
                </td>
                <td style="width: 15%">
                  <vs-button
                    color="primary"
                    type="border"
                    icon-pack="feather"
                    icon="icon-eye"
                    class="custom-border-btn mr-4"
                    @click="
                      isShowalternativeWarrantyItemsPopup(
                        row.alternativeWarrantyItems,
                        row.mainWarranty
                      )
                    "
                    >{{ $t("Details") }}</vs-button
                  >
                </td>
              </template>
            </data-grid>
            <alternative-warranty-items-popup
              :show="onShowalternativeWarrantyItemsPopup"
              :alternativeWarrantyItems="alternativeWarrantyItems"
              :mainWarranty="mainWarranty"
              @finish="onfinish"
            ></alternative-warranty-items-popup>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import AlternativeWarrantyItemsPopup from "./DetailsPopup.vue";

export default {
  components: {
    DataGrid,
    AlternativeWarrantyItemsPopup,
  },
  data() {
    return {
      permission244: "UpdateKhadamatWarranty",
      onShowalternativeWarrantyItemsPopup: false,
      alternativeWarrantyItems: [],
      mainWarranty: {},
      gridDataSource: {
        type: "app",
        service: "ProductManagement/api/ProductKhadamatWarrantiesQuery",
      },
      gridSearchData: {},
    };
  },
  methods: {
    ...mapActions({
      UpdateFromKhadamat: "warranty/UpdateFromKhadamat",
    }),
    isShowalternativeWarrantyItemsPopup(
      alternativeWarrantyItems,
      mainWarranty
    ) {
      this.onShowalternativeWarrantyItemsPopup = true;
      this.alternativeWarrantyItems = alternativeWarrantyItems;
      this.mainWarranty = mainWarranty;
    },
    search() {
      setTimeout(() => {
        this.$refs.grid.renderGrid();
      }, 2000);
    },
    isUpdateDataFromKhadamat() {
      this.UpdateFromKhadamat().then(() => {
        this.$swal({
          position: "center-center",
          type: "success",
          text: "به روز رسانی با موفقیت انجام شد!",
          showConfirmButton: false,
          timer: 2000,
        });
      });
    },
    onfinish() {
      this.onShowalternativeWarrantyItemsPopup = false;
    },
  },
};
</script>
